import { BillingReasonType, } from '@debbie/common/dist/economy/billing-models/index.js';
import { useBillingReasons } from '@debbie/cortex/dist/billing-reasons/index.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Money from '../Money.js';
import PerformedBy from '../performed-by/PerformedBy.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
const BillingReasons = (props) => {
    const billingReasonsLoadable = useBillingReasons(props.depositCaseVoucherId, props.billingId);
    const billingReasons = h.hasData(billingReasonsLoadable)
        ? billingReasonsLoadable.data
        : null;
    return (React.createElement(StyledBillingReasons, null,
        h.isLoading(billingReasonsLoadable) && React.createElement(PlaceholderLoader, null),
        billingReasons
            ? billingReasons
                .sort((a, b) => new Date(a.createdAt).getTime() -
                new Date(b.createdAt).getTime())
                .map((billingReason) => (React.createElement(BillingReasonCmp, { key: billingReason.billingReasonId, billingReason: billingReason, caseId: props.caseId })))
            : null));
};
export default BillingReasons;
const BillingReasonCmp = (props) => {
    const { createdAt, performedBy } = props.billingReason;
    BillingReasonType.VoucherPatched;
    return (React.createElement(StyledBillingReason, null,
        React.createElement(PerformedBy, { performedBy: performedBy }),
        React.createElement("p", { style: {
                flexGrow: 1,
                margin: '0px 10px 0px 10px',
                alignContent: 'center',
                fontSize: '0.8em',
            } },
            React.createElement(BillinReasonDetails, { billingReason: props.billingReason, caseId: props.caseId })),
        React.createElement("span", { style: { fontWeight: 900, fontSize: '0.7em', alignContent: 'center' } }, moment(createdAt).format(THEME.DATE_FORMAT_LONG))));
};
const StyledBillingReasons = styled.div `
  margin-bottom: ${THEME.GRID_SPACING / 2}px;
`;
const StyledBillingReason = styled.div `
  margin-bottom: 3px;
  background-color: ${THEME.FILL};
  border-radius: 3px;
  padding: 5px 8px;
  display: flex;
`;
const CaseVoucherInline = (props) => {
    const { caseVoucher } = props;
    const lang = useSelector((s) => s.lang);
    if (!caseVoucher) {
        return React.createElement(React.Fragment, null, lang.billingReasons.caseVoucherInlineDeleted);
    }
    return (React.createElement(React.Fragment, null,
        lang.economyVoucherTypeLabels[caseVoucher.voucherTypeId] || caseVoucher.label,
        ' ',
        caseVoucher.referenceId,
        " ",
        React.createElement(Money, { amount: caseVoucher.amount })));
};
const BillinReasonDetails = (props) => {
    const { type, details } = props.billingReason;
    const lang = useSelector((s) => s.lang);
    const caseVouchers_ = useCaseVouchersByCase(props.caseId ?? undefined);
    const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    switch (type) {
        case BillingReasonType.VoucherPatched: {
            const caseVoucher = caseVouchers?.find((caseVoucher) => details.caseVoucherId === caseVoucher.caseVoucherId);
            if (details.patch.caseId) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("b", null,
                        React.createElement(CaseVoucherInline, { caseVoucher: caseVoucher })),
                    ' ',
                    lang.billingReasons.caseVoucherPatchedCaseId));
            }
            else {
                return (React.createElement("span", { title: JSON.stringify(details.patch) },
                    React.createElement("b", null,
                        React.createElement(CaseVoucherInline, { caseVoucher: caseVoucher })),
                    ' ',
                    lang.billingReasons.caseVoucherPatched));
            }
        }
        case BillingReasonType.VoucherCreated: {
            const _caseVouchers = caseVouchers?.filter((caseVoucher) => details.caseVoucherIds.includes(caseVoucher.caseVoucherId));
            return (React.createElement(React.Fragment, null,
                _caseVouchers?.length ? (_caseVouchers.map((caseVoucher) => (React.createElement(CaseVoucherInline, { key: caseVoucher.caseVoucherId, caseVoucher: caseVoucher })))) : (React.createElement(CaseVoucherInline, null)),
                ' ',
                lang.billingReasons.caseVoucherCreated));
        }
        case BillingReasonType.VoucherDeleted: {
            return (React.createElement(React.Fragment, null,
                React.createElement("b", null, details.caseVouchers.map((caseVoucher) => (React.createElement(React.Fragment, null,
                    lang.economyVoucherTypeLabels[caseVoucher.voucherTypeId] || caseVoucher.label,
                    ' ',
                    caseVoucher.referenceId,
                    " ",
                    React.createElement(Money, { amount: caseVoucher.amount }))))),
                ' ',
                lang.billingReasons.caseVoucherDeleted));
        }
        case BillingReasonType.BillingModelChanged: {
            return React.createElement(React.Fragment, null, lang.billingReasons.billingModelChanged);
        }
        case BillingReasonType.BillingStartDateChanged: {
            return React.createElement(React.Fragment, null, lang.billingReasons.billingStartDateChanged);
        }
        case BillingReasonType.BillingModelPatched: {
            return React.createElement(React.Fragment, null, lang.billingReasons.billingModelChanged);
        }
        case BillingReasonType.Reconciliation:
            return null;
        default: {
            console.warn(`Billing reason not handled ${type}`);
            return null;
        }
    }
};
//# sourceMappingURL=BillingReasons.js.map